module.exports = __webpack_public_path__ + "static/media/more.a9a67f73.png";